<template>
    <BaseCard padding="md" class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div class="flex items-start gap-3 min-w-0 flex-1">
            <ReflectionIcon :kind="kind" size="md" class="mt-0.5 shrink-0" />
            <div class="flex flex-col gap-0.5 min-w-0">
                <div class="body-semibold text-valence-stone-900">{{ title }}</div>
                <p class="scaffold-body-small text-valence-stone-500"><slot /></p>
            </div>
        </div>
        <a
            v-if="href"
            :href="href"
            class="base-btn-neutral base-btn-square base-btn-sm sm:shrink-0 whitespace-nowrap text-center self-start sm:self-auto"
            @click.prevent="emit('launch')">
            Launch
        </a>
    </BaseCard>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import ReflectionIcon, { type ReflectionIconKind } from "~vue/pages/reflections/ReflectionIcon.vue";

interface Props {
    kind: ReflectionIconKind;
    title: string;
    // Rows without a destination (team review) render as copy only, since
    // giving feedback depends on a teammate asking first.
    href?: string;
}

defineProps<Props>();
const emit = defineEmits<{ (event: "launch"): void }>();
</script>
